import React from 'react';

function Header() {
  return (
    <header className="tc-inner-header-style1">
      <div className="container">
        <div className="info col-lg-7">
          <h1 className="js-title" style={{ fontSize: '11.5rem' }}>Projects</h1>
          <div className="text fsz-18 color-666">
            Building tomorrow’s landmarks today.
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
